import React from 'react'
import PropTypes from 'prop-types'
import Component from '../common/Component'
import fieldGroups, { infoFields, externalIdField, benefitNames } from './fields'
import BenefitsSetDocuments from './LargeGroupCustomBenefitsSetDocuments'
import BenefitsSetComponent from '../BenefitsSet/BenefitsSetComponent'

export default class LargeGroupCustomBenefitsSetComponent extends Component {
  static propTypes = {
    benefitsSet: PropTypes.object.isRequired,
    show: PropTypes.func.isRequired,
    showReset: PropTypes.func.isRequired
  }

  render() {
    return (
      <div>
        <BenefitsSetDocuments
          benefitsSet={this.props.benefitsSet}
          show={this.props.show}
          showReset={this.props.showReset}
        />

        <BenefitsSetComponent
          fieldGroups={fieldGroups}
          infoFields={infoFields}
          externalIdField={externalIdField}
          benefitNames={benefitNames}
          {...this.props}
        />
      </div>
    )
  }
}
